export default "__VITE_ASSET__c8f9ab0a__"